export default __webpack_public_path__ + "static/media/text-only.76ab52ae.svg";